import React, {Component} from 'react';
import {Router, Route} from 'react-router-dom';
import Home from './Home';
import Profile from './Profile';
import Assets from './Assets';
import Game from './Game';
import Currency from './Currency';
import Store from './Store';
import Character from './Character';
import AssetDescription from './AssetDescription';
import ActiveUser from './ActiveUser';
import history from './History';
import ExcelReader from './ExcelReader';

class Main extends Component {
    constructor(props){        
        super(props);

        window.$backend_url = "http://localhost:5001";
        // window.$backend_url = "/api";
    }

    render(){
        return(
            <div history={history}>
                <Route exact path="/" component={Home}/>
                <Route path="/profile" component={Profile}/>
                <Route path="/assets" component={Assets}/>
                <Route path="/games" component={Game}/>
                <Route path="/currency" component={Currency}/>
                <Route path="/store" component={Store}/>
                <Route path="/characterDescription" component={Character}/>
                <Route path="/assetDescription" component={AssetDescription}/>
                <Route path="/activeUser" component={ActiveUser}/>
                
            </div>
        )
    }

}

// <Route path="/data" component={ExcelReader}/>
//Export The Main Component
export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js